import React, { useState, useEffect, Suspense, lazy } from 'react';

// The entire 3D scene (and the Three.js bundle it pulls in) is split into a
// separate chunk and only loaded once the browser is idle, so the hero's
// initial paint is fast and Three.js never blocks first render.
const HeroScene = lazy(() => import('./HeroScene'));

const Hero = () => {
  const [isProfilePictureModalOpen, setIsProfilePictureModalOpen] = useState(false);
  const [show3D, setShow3D] = useState(false);

  useEffect(() => {
    const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 200));
    const cancelIdle = window.cancelIdleCallback || clearTimeout;
    const handle = idle(() => setShow3D(true));
    return () => cancelIdle(handle);
  }, []);

  const openProfilePictureModal = () => setIsProfilePictureModalOpen(true);
  const closeProfilePictureModal = () => setIsProfilePictureModalOpen(false);

  return (
    <section id="hero-section" className="hero-section">
      <div className="hero-content">
        <div className="hero-profile-picture-container" onClick={openProfilePictureModal}>
          <img src="/images/brian.jpeg" alt="Brian Kipruto Profile" className="hero-profile-picture" />
        </div>
        <h1>Brian Kipruto</h1>
        <p>
          Hi there. I'm Kipruto, from Kenya. I'm an astrophysicist by training, but my passion lies
          more in the particle and matter side of physics than in the sheer vastness of the universe.
        </p>
        <p>
          I enjoy tinkering with electronics, the outdoors, grilling, and — boy — am I a sucker for
          scenic views. I'm currently working on my MSc and I'm particularly interested in designing
          and building nuclear technologies for space-based applications.
        </p>
        <p>
          My overarching philosophy in life is that <strong>Motion is Key</strong> — always be doing
          something with yourself, no matter how small.
        </p>
      </div>
      <div className="hero-canvas">
        {/* Poster image shows instantly; the 3D scene replaces it once mounted. */}
        {show3D ? (
          <Suspense fallback={
            <div className="hero-canvas-poster" aria-hidden="true">
              <img src="/models/nuclear-fission-poster.png" alt="" className="hero-canvas-poster-img"
                onError={(e) => { e.target.style.display = 'none'; }} />
            </div>
          }>
            <HeroScene />
          </Suspense>
        ) : (
          <div className="hero-canvas-poster" aria-hidden="true">
            <img src="/models/nuclear-fission-poster.png" alt="" className="hero-canvas-poster-img"
              onError={(e) => { e.target.style.display = 'none'; }} />
          </div>
        )}
      </div>

      {isProfilePictureModalOpen && (
        <div className="profile-picture-modal-overlay" onClick={closeProfilePictureModal}>
          <div className="profile-picture-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal-btn" onClick={closeProfilePictureModal}>&times;</button>
            <img src="/images/brian.jpeg" alt="Brian Kipruto Profile Enlarged" className="enlarged-profile-picture" />
            <p className="enlarged-profile-caption">Brian Kipruto</p>
            <p className="enlarged-profile-subcaption">MSc Nuclear Science &amp; Technology Student</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Hero;